import classnames from "classnames";
import { asField } from "informed";
import React, { Fragment } from "react";

function FileUploader({ fieldState, fieldApi, faClass, ...props }) {
  const { value } = fieldState;
  const { setValue, setTouched } = fieldApi;
  const {
    field,
    onChange,
    onBlur,
    initialValue,
    forwardedRef,
    className,
    content,
    ...rest
  } = props;
  let event;
  function FileonChange(e) {
    event = e;
    if (onChange) props.onChange(event);
  }
  return (
    <Fragment>
      <div className="form-group">
        {faClass && <i className={faClass}></i>}
        {props.label && (
          <label htmlFor={field}>
            {props.label}
            {props.required && <i style={{ color: "red" }}>*</i>}
          </label>
        )}

        <input
          {...rest}
          id={field}
          ref={forwardedRef}
          type="file"
          required={false}
          value={!value && value !== 0 ? "" : value}
          className={classnames(`form-control ${className}`, {
            "is-invalid": fieldState.error,
          })}
          onChange={(e) => {
            FileonChange(e);
            setValue(e.target.value);
          }}
          onBlur={(e) => {
            setTouched(true);
            if (onBlur) {
              onBlur(e);
            }
          }}
        />
        {props.helper && (
          <small className="form-text text-muted">{content}</small>
        )}

        {fieldState.error ? (
          <div className="invalid-field">{fieldState.error}</div>
        ) : null}
        {event && (
          <img
            id="MainContent_imgBtRtPrev"
            alt="Select File"
            title="Select File"
            src={event.target.value}
            style={{ width: "150px", height: "150px" }}
          />
        )}
      </div>
    </Fragment>
  );
}

export default asField(FileUploader);
